import { render, staticRenderFns } from "./OrderDetailsLog.vue?vue&type=template&id=172efb95"
import script from "./OrderDetailsLog.vue?vue&type=script&lang=js"
export * from "./OrderDetailsLog.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailsLog.vue?vue&type=style&index=0&id=172efb95&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports